module.exports = __webpack_public_path__ + "img/sophie_living_visualisation.e0a3b68c.png";